import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function Message(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="145"
      viewBox="0 0 200 145"
      width="200"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_41585_204582"
          x1="82.267"
          x2="82.267"
          y1="16.7472"
          y2="112.495"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F7FE" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_41585_204582"
          x1="116"
          x2="69.7569"
          y1="13"
          y2="97.7754"
        >
          <stop stopColor="#F0F5FD" />
          <stop offset="1" stopColor="#C4D1ED" />
        </linearGradient>
      </defs>
      <path
        d="M10.8921 30.0979C-21.0228 90.5233 25.2205 111.374 47.0623 144.566H148.764C203.232 144.566 226.637 86.2681 152.169 59.8851C77.7005 33.5021 48.6583 -41.4059 10.8921 30.0979Z"
        fill="url(#paint0_linear_41585_204582)"
      />
      <path
        d="M169.029 13H62.9714C56.9371 13 52 17.95 52 24V123L73.9429 101H169.029C175.063 101 180 96.05 180 90V24C180 17.95 175.063 13 169.029 13Z"
        fill="url(#paint1_linear_41585_204582)"
      />
      <path
        d="M75.6364 50.4545H72.6179L77.1562 57.7273L72.5611 65H75.6009L78.8395 59.7088H78.9531L82.1918 65H85.2457L80.6932 57.7273L85.1747 50.4545H82.1705L78.9531 55.7812H78.8395L75.6364 50.4545ZM89.445 50.4545H86.4265L90.9648 57.7273L86.3697 65H89.4094L92.6481 59.7088H92.7617L96.0004 65H99.0543L94.5018 57.7273L98.9833 50.4545H95.979L92.7617 55.7812H92.6481L89.445 50.4545ZM103.254 50.4545H100.235L104.773 57.7273L100.178 65H103.218L106.457 59.7088H106.57L109.809 65H112.863L108.31 57.7273L112.792 50.4545H109.788L106.57 55.7812H106.457L103.254 50.4545ZM122.023 50.4545H119.005L123.543 57.7273L118.948 65H121.988L125.226 59.7088H125.34L128.578 65H131.632L127.08 57.7273L131.561 50.4545H128.557L125.34 55.7812H125.226L122.023 50.4545ZM135.832 50.4545H132.813L137.352 57.7273L132.756 65H135.796L139.035 59.7088H139.148L142.387 65H145.441L140.888 57.7273L145.37 50.4545H142.366L139.148 55.7812H139.035L135.832 50.4545ZM149.64 50.4545H146.622L151.16 57.7273L146.565 65H149.605L152.843 59.7088H152.957L156.196 65H159.25L154.697 57.7273L159.179 50.4545H156.174L152.957 55.7812H152.843L149.64 50.4545Z"
        fill="#B0BFDD"
      />
    </SvgIcon>
  )
}

export default Message
